module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img32.ea4550e7.jpg";